
import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import  Col  from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import TableComponent from "../components/TableComponent";
import { fetchData } from "../services/airtableService";

const MainContainer = () =>{

    const [data, setData] = useState([])
    const [loader, setLoader] = useState(false)

    useEffect(()=>{

        fetchTableData()
    },[])

    const fetchTableData =  async()=>{
        setLoader(true)

    const result = await  fetchData();
    if(result && result.records){
        setData(result.records)

    }
    setLoader(false)
    }

return(<Container fluid>
<Row>
  <Col>
 
  <TableComponent data={data} loader={loader} />
  </Col>
 
</Row>
</Container>)

}

export default MainContainer